export const ogTypeOptions = [
  "website",
  "article",
  "book",
  "profile",
  "business.business",
  "books.author",
  "books.book",
  "books.genre",
  "fitness.course",
  "game.achievement",
  "music.musician",
  "music.song",
  "music.album",
  "music.playlist",
  "music.radio_station",
  "place",
  "product",
  "product.group",
  "product.item",
  "restaurant.menu",
  "restaurant.menu_item",
  "restaurant.menu_section",
  "restaurant.restaurant",
  "video.movie",
  "video.episode",
  "video.tv_show",
  "video.other",
  "object",
];

export const ogLocaleOptions = [
  ["af_ZA", "Afrikaans (South Africa)"],
  ["ar_AR", "Arabic"],
  ["az_AZ", "Azerbaijani"],
  ["be_BY", "Belarusian"],
  ["bg_BG", "Bulgarian"],
  ["bn_IN", "Bengali (India)"],
  ["bs_BA", "Bosnian"],
  ["ca_ES", "Catalan"],
  ["cs_CZ", "Czech"],
  ["cy_GB", "Welsh"],
  ["da_DK", "Danish"],
  ["de_DE", "German"],
  ["el_GR", "Greek"],
  ["en_GB", "English (United Kingdom)"],
  ["en_IN", "English (India)"],
  ["en_US", "English (United States)"],
  ["es_ES", "Spanish (Spain)"],
  ["es_LA", "Spanish (Latin America)"],
  ["fr_CA", "French (Canada)"],
  ["fr_FR", "French (France)"],
  ["hi_IN", "Hindi (India)"],
  ["it_IT", "Italian"],
  ["ja_JP", "Japanese"],
  ["ko_KR", "Korean"],
  ["nl_NL", "Dutch"],
  ["pt_BR", "Portuguese (Brazil)"],
  ["pt_PT", "Portuguese (Portugal)"],
  ["ru_RU", "Russian"],
  ["ta_IN", "Tamil"],
  ["te_IN", "Telugu"],
  ["zh_CN", "Chinese (Simplified)"],
  ["zh_HK", "Chinese (Hong Kong)"],
  ["zh_TW", "Chinese (Traditional)"],
];

export const twitterCardOptions = [
  "summary",
  "summary_large_image",
  "app",
  "player",
];

const derivedFields = {
  url: ["og_url"],
  title: ["og_title", "twitter_title"],
  description: ["og_description", "twitter_description"],
  og_image: ["twitter_image"],
};

export const updateSeoField = (current, name, value) => {
  const next = { ...current, [name]: value };
  (derivedFields[name] || []).forEach((field) => {
    next[field] = value;
  });
  return next;
};

export const synchronizeSeoFields = (seoData) => ({
  ...seoData,
  og_url: seoData.url || "",
  og_title: seoData.title || "",
  twitter_title: seoData.title || "",
  og_description: seoData.description || "",
  twitter_description: seoData.description || "",
  twitter_image: seoData.og_image || "",
});

export const buildPageSeoPayload = (seoData) => {
  const pageSeoPayload = synchronizeSeoFields(seoData);
  [
    "review_schema",
    "organisation_schema",
    "organization_schema",
    "twitter_site",
    "twitter_card",
    "twitter_creator",
    "og_site_name",
  ].forEach((field) => delete pageSeoPayload[field]);
  return pageSeoPayload;
};
